/**
 * Http methods supported
 */
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["OPTIONS"] = "OPTIONS";
    HttpMethod["HEAD"] = "HEAD";
})(HttpMethod || (HttpMethod = {}));
/**
 * Error types returned from NetworkProxyPlugin
 */
export var NetworkProxyPluginErrorCode;
(function (NetworkProxyPluginErrorCode) {
    NetworkProxyPluginErrorCode["requestError"] = "requestError";
    NetworkProxyPluginErrorCode["invalidRequest"] = "invalidRequest";
    NetworkProxyPluginErrorCode["domainNotSupported"] = "domainNotSupported";
})(NetworkProxyPluginErrorCode || (NetworkProxyPluginErrorCode = {}));
//# sourceMappingURL=network-proxy.js.map